import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  templateUrl: "./validation-modal.component.html",
})
export class ValidationModalComponent {
  @Input() title: string = "Validating";   // Modal title
  @Input() message?: string;                // Error or info message
  @Input() isError: boolean = true;        // Red text for validation errors

  constructor(public activeModal: NgbActiveModal) {}
}
